import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viCalendar, viSpinnerThird, viTrashCan } from "@sippy-platform/valkyrie";

import { Card, IconButton, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function HolidaySetItem({ timetable, holidaySet, timetableDispatch }) {
  const [pending, setPending] = useState(false);

  const removeHolidaySet = () => {
    setPending(true);

    Promise.resolve(Api.deleteTimetableHolidaySet(timetable, holidaySet))
      .then(() => timetableDispatch({ type: "removeHolidaySet", holidaySet }))
      .finally(() => setPending(false));
  };

  return (
    <Card variant="outlined">
      <List>
        <ListItem
          secondaryAction={
            <IconButton color="inherit" onClick={() => removeHolidaySet()}>
              <Valkyrie icon={pending ? viSpinnerThird : viTrashCan} spin={pending} />
            </IconButton>
          }
        >
          <ListItemAvatar>
            <Avatar text={holidaySet.name} icon={viCalendar} />
          </ListItemAvatar>
          <ListItemText primary={holidaySet.name} />
        </ListItem>
      </List>
    </Card>
  );
}

HolidaySetItem.propTypes = {
  timetable: PropTypes.object,
  holidaySet: PropTypes.object,
  timetableDispatch: PropTypes.func,
};

export default HolidaySetItem;
